import React from 'react';
import { Plus } from 'lucide-react';
import { StoryGroup } from '../../types/story';

interface StoryRingProps {
  storyGroup?: StoryGroup;
  isAddStory?: boolean;
  onClick: () => void;
  size?: 'sm' | 'md' | 'lg';
}

const StoryRing: React.FC<StoryRingProps> = ({
  storyGroup,
  isAddStory = false,
  onClick,
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'w-12 h-12',
    md: 'w-16 h-16',
    lg: 'w-20 h-20'
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  const getInitials = (name: string) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };

  if (isAddStory) {
    return (
      <div className="flex flex-col items-center space-y-1 cursor-pointer" onClick={onClick}>
        <div className={`${sizeClasses[size]} relative`}>
          <div className="w-full h-full rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center bg-gray-50 hover:bg-gray-100 transition-colors">
            <Plus className="w-6 h-6 text-gray-400" />
          </div>
        </div>
        <span className={`${textSizeClasses[size]} text-gray-600 text-center max-w-[60px] truncate`}>
          Your Story
        </span>
      </div>
    );
  }

  if (!storyGroup) return null;

  const { user, hasUnviewed } = storyGroup;

  return (
    <div className="flex flex-col items-center space-y-1 cursor-pointer" onClick={onClick}>
      <div className={`${sizeClasses[size]} relative`}>
        {/* Story Ring */}
        <div className={`
          w-full h-full rounded-full p-0.5 
          ${hasUnviewed 
            ? 'bg-gradient-to-tr from-purple-500 via-pink-500 to-orange-500' 
            : 'bg-gray-300'
          }
        `}>
          <div className="w-full h-full rounded-full bg-white p-0.5">
            <div className="w-full h-full rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
              {user.avatar ? (
                <img
                  src={user.avatar}
                  alt={user.name}
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-gray-600 font-medium text-sm">
                  {getInitials(user.name)}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Unviewed Indicator */}
        {hasUnviewed && (
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border-2 border-white flex items-center justify-center">
            <div className="w-2 h-2 bg-white rounded-full"></div>
          </div>
        )}
      </div>

      {/* User Name */}
      <span className={`${textSizeClasses[size]} text-gray-900 text-center max-w-[60px] truncate`}>
        {user.name.split(' ')[0]}
      </span>
    </div>
  );
};

export default StoryRing;